/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PurposeWithTemplateIdList,
    PurposeWithTemplateIdListFromJSON,
    PurposeWithTemplateIdListFromJSONTyped,
    PurposeWithTemplateIdListToJSON,
} from './PurposeWithTemplateIdList';

/**
 * テンプレート一覧
 * @export
 * @interface Templates
 */
export interface Templates {
    /**
     * カテゴリ名
     * @type {string}
     * @memberof Templates
     */
    categoryName: string;
    /**
     * 配信目的リスト
     * @type {Array<PurposeWithTemplateIdList>}
     * @memberof Templates
     */
    purposeList: Array<PurposeWithTemplateIdList>;
}

export function TemplatesFromJSON(json: any): Templates {
    return TemplatesFromJSONTyped(json, false);
}

export function TemplatesFromJSONTyped(json: any, ignoreDiscriminator: boolean): Templates {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'categoryName': json['category_name'],
        'purposeList': ((json['purpose_list'] as Array<any>).map(PurposeWithTemplateIdListFromJSON)),
    };
}

export function TemplatesToJSON(value?: Templates | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'category_name': value.categoryName,
        'purpose_list': ((value.purposeList as Array<any>).map(PurposeWithTemplateIdListToJSON)),
    };
}

